'use client';

// module imports
import { useState } from 'react';

interface ProfileToggleProps {
  label: string;
  tooltip?: string;
  value: boolean;
  onToggle: (value: boolean) => void;
  className?: string;
  labelClassName?: string;
  disabled?: boolean;
}

export default function ProfileToggle({ label, tooltip, value, onToggle, className = '', labelClassName = '', disabled = false }: ProfileToggleProps) {
  const [saving, setSaving] = useState(false);

  const handleToggle = async () => {
    if (disabled || saving) return;

    setSaving(true);
    try {
      await onToggle(!value);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`flex flex-row items-center justify-between gap-3 sm:gap-4 ${className}`}>
      <div className={`text-gray-500 text-sm sm:text-base flex-1 ${labelClassName}`}>
        <div className="font-medium" title={tooltip || ''}>
          {label}
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
        <span className="text-gray-500 text-sm sm:text-base">{value ? 'Enabled' : 'Disabled'}</span>
        <label className="flex items-center cursor-pointer">
          <input type="checkbox" className="sr-only" checked={value} onChange={handleToggle} disabled={disabled || saving} />
          <div className={`w-10 h-6 sm:w-12 sm:h-7 flex items-center rounded-full p-1 duration-300 ease-in-out ${value ? 'bg-[#5167b2]' : 'bg-gray-200'} ${disabled || saving ? 'opacity-50 cursor-not-allowed' : ''}`}>
            <div className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full shadow-md transform duration-300 ease-in-out ${value ? 'bg-white translate-x-4 sm:translate-x-5' : 'bg-white'}`} />
          </div>
        </label>
      </div>
    </div>
  );
}
